<template>
  <button
    :class="[
      'inline-flex items-center justify-center font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-900',
      formRoundingClasses.button,
      sizeClasses[size as ElementSizeType],
      variantClasses[variant],
      { 'w-full': fullWidth },
      { 'opacity-50 cursor-not-allowed': disabled },
      { 'opacity-75 cursor-wait': loading }
    ]"
    :disabled="disabled || loading"
    v-bind="$attrs"
  >
    <template v-if="loading">
      <UISpinner
        :size="size"
        :style="variant"
      />
    </template>
    <template v-else>
      <slot />
    </template>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getConfig, getFormRoundingClasses } from '@/config'
import { sizeClasses } from '@/config'
import UISpinner from './UISpinner.vue'
import type { ElementSizeType } from '@/types'

const props = withDefaults(defineProps<{
  variant?: 'primary' | 'secondary' | 'outline' | 'danger' | 'light' | 'plain'
  size?: ElementSizeType
  fullWidth?: boolean
  disabled?: boolean
  loading?: boolean
}>(), {
  variant: 'primary',
  size: 'md'
})

const config = getConfig()
const formRoundingClasses = getFormRoundingClasses(config)

const variantClasses = computed(() => ({
  primary: `bg-primary text-white `,
  secondary: `bg-secondary text-white hover:opacity-90`,
  outline: 'border border-gray-300 dark:border-gray-600 bg-transparent hover:bg-gray-50 dark:hover:bg-gray-600 dark:text-white',
  danger: 'bg-red-600 text-white hover:bg-red-700',
  light: 'bg-white text-black hover:opacity-90',
  plain: 'bg-transparent text-black hover:opacity-90 dark:text-gray-300'
}))
</script> 